import React from 'react';
import '../styles/FAQ.css';

const FAQ: React.FC = () => {
  return (
    <section id="faq" className="section faq-section">
      <div className="container">
        <div className="section-header">
          <h2>Frequently Asked Questions</h2>
          <p>Common questions about Komodo Classic and the fork</p>
        </div>
        
        <div className="faq-content">
          <div id="faq-q1" className="faq-item">
            <div className="faq-question">
              <strong><a href="#faq-q1" className="faq-question-link">Q1.</a> What is Komodo Classic (KMDCL)?</strong>
            </div>
            <div className="faq-answer">
              <p>Komodo Classic is a community-driven fork of Komodo (KMD) that aims to preserve and restore the original features and economic parameters that attracted early adopters. It maintains the original 5% AUR (Active User Reward), preserves the 3 KMDCL block reward, and restores privacy features that were disabled in the main Komodo chain.</p>
            </div>
          </div>
          
          <div id="faq-q2" className="faq-item">
            <div className="faq-question">
              <strong><a href="#faq-q2" className="faq-question-link">Q2.</a> How ready is the project at this point?</strong>
            </div>
            <div className="faq-answer">
              <p>As of December 18, 2025, we have implemented virtually all of the initially announced features. The codebase is currently undergoing internal testing. We have also opened early access to the source code on GitHub, but please note that everything may change before the official release - new commits may be added, features may be modified, etc. Keep an eye on the <a href="https://github.com/kmdclassic/KmdClassic/releases" target="_blank" rel="noopener noreferrer">Releases section</a> on GitHub for binary distributions. Until then, the current version should be considered dev/nightly.</p>
            </div>
          </div>
          
          <div id="faq-q3" className="faq-item">
            <div className="faq-question">
              <strong><a href="#faq-q3" className="faq-question-link">Q3.</a> When will the Hard Fork occur? What will it consist of?</strong>
            </div>
            <div className="faq-answer">
              <p>The <strong>Dormancy</strong> hard fork and KMDCL launch will occur at block <strong>#4771595</strong>. As we noted in our <a href="https://t.me/komodoclassic/11" target="_blank" rel="noopener noreferrer">Telegram channel</a>, the same block is scheduled for a global KMD update that will disable dPoW and transition the original KMD network to a single master node mode with auto-checkpoints. After block #4771595, KMD and KMDCL will represent two distinct networks with their own consensus rules and independent blockchains. Think of it like BTC (Bitcoin) and BCH (Bitcoin Cash) - KMD (Komodo) and KMDCL (Komodo Classic) follow the same principle.</p>
            </div>
          </div>
          
          <div id="faq-q4" className="faq-item">
            <div className="faq-question">
              <strong><a href="#faq-q4" className="faq-question-link">Q4.</a> How will I be able to claim my KMDCL coins? Will there be any additional supply or separate coins for developers?</strong>
            </div>
            <div className="faq-answer">
              <p>No, there will be no additional supply or separate KMDCL coins allocated to the development team. If you hold KMD coins in your wallet (you must own the private keys for all your coins) at the time of block #4771595, you will receive the same amount (1:1) of KMDCL coins. To access your KMDCL, simply import your private keys into the Komodo Classic wallet.</p>
            </div>
          </div>
          
          <div id="faq-q5" className="faq-item">
            <div className="faq-question">
              <strong><a href="#faq-q5" className="faq-question-link">Q5.</a> What about the exchange? You mentioned that KMDCL can be exchanged for KMD and vice versa at any time?</strong>
            </div>
            <div className="faq-answer">
              <p>Yes, indeed. The launch of a DEX for such exchanges is planned. However, we cannot provide exact timelines at this moment. The exchange is tentatively scheduled to launch within the first month after KMDCL goes live. Our team is working to provide it to users as soon as possible, but our primary focus right now is on launching the KMDCL network itself.</p>
            </div>
          </div>
          
          <div id="faq-q6" className="faq-item">
            <div className="faq-question">
              <strong><a href="#faq-q6" className="faq-question-link">Q6.</a> What about Notary Nodes? What will happen to them after block #4771595?</strong>
            </div>
            <div className="faq-answer">
              <p>Unlike the main Komodo (KMD) network, which will disable dPoW and transition to pure PoW after block #4771595, Komodo Classic will preserve the dPoW consensus mechanism. This means that Notary Nodes will continue to be an integral part of the KMDCL network long after the fork. Season 8 Notary Node operators can seamlessly continue their operations on Komodo Classic, retaining their ability to perform "easy-mining" with minimum difficulty and earn the 3 KMDCL block reward. The Season 8 Notary Node pubkeys remain unchanged in Komodo Classic, ensuring a smooth transition for current operators. For detailed information and instructions, please see our <a href="/notary-nodes" target="_blank" rel="noopener noreferrer">message to Komodo Notary Node Operators</a>.</p>
            </div>
          </div>
          
          <div id="faq-q7" className="faq-item">
            <div className="faq-question">
              <strong><a href="#faq-q7" className="faq-question-link">Q7.</a> Are my coins in the KMD/KMDCL network protected from replay attacks?</strong>
            </div>
            <div className="faq-answer">
              <p>Yes, this is one of the built-in features of the <strong>Dormancy</strong> update. Any transaction from the KMD network, if someone attempts to copy and broadcast it on the KMDCL network, will be considered invalid, and vice versa. In other words, all your coins are protected by default against this type of attack.</p>
            </div>
          </div>
          
          <div id="faq-q8" className="faq-item">
            <div className="faq-question">
              <strong><a href="#faq-q8" className="faq-question-link">Q8.</a> What about the fundraising? I see that the project didn't reach the planned amount.</strong>
            </div>
            <div className="faq-answer">
              <p>Yes, that's correct. However, we have decided to proceed with the project regardless of the amount raised, as we are deeply committed to the original Komodo technologies and want to restore them to their original state. You can use the donation address for voluntary donations to our development team. There is no limit on donation amounts, and all funds collected will be used for project development. You can use the donation address to send both <a href="https://kmdexplorer.io/address/RAUk9TY9FhcD3h99twffFcf4gtaEL7F78R" target="_blank" rel="noopener noreferrer">KMD</a> and <a href="https://explorer.kmdclassic.com/address/RAUk9TY9FhcD3h99twffFcf4gtaEL7F78R" target="_blank" rel="noopener noreferrer">KMDCL</a> coins.</p>
            </div>
          </div>
          
          <div id="faq-q9" className="faq-item">
            <div className="faq-question">
              <strong><a href="#faq-q9" className="faq-question-link">Q9.</a> Where can I get additional information about the project?</strong>
            </div>
            <div className="faq-answer">
              <p>We publish all our news first in our <a href="https://t.me/komodoclassic" target="_blank" rel="noopener noreferrer">Telegram channel</a>, and then on the <a href="https://kmdclassic.com/" target="_blank" rel="noopener noreferrer">website</a>. To stay up to date with the latest news, make sure to subscribe. We would also appreciate it if you share information about us on social media.</p>
            </div>
          </div>
          
          
        </div>
      </div>
    </section>
  );
};

export default FAQ;

